import React from "react";
import {Doughnut} from "react-chartjs-2";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const AssetStatus = ({data}) => {
  if (!data) {
    return (
      <div className="card">
        <div className="card-header">
          <h5 className="m-0">Estado de contenedores</h5>
        </div>
        <div className="card-body">
          <div className="text-center">Cargando datos...</div>
        </div>
      </div>
    );
  }

  const statusNames = {
    ac: "Activo",
    rp: "Reparación",
    rs: "Reposición",
    ds: "Descartado",
    cb: "Calibración",
    ns: "Sin sensor",
  };

  const statusColors = {
    ac: "#28a745", // verde
    rp: "#fd7e14", // naranja
    rs: "#007bff", // azul
    ds: "#dc3545", // rojo
    cb: "#6f42c1", // morado
    ns: "#6c757d", // gris
  };

  const statusLabels = Object.keys(data.status).map(
    (key) => statusNames[key] || key
  );
  const statusValues = Object.values(data.status);
  const total = statusValues.reduce((sum, val) => sum + val, 0);

  const colors = Object.keys(data.status).map((key) => statusColors[key]);

  const chartData = {
    labels: statusLabels,
    datasets: [
      {
        label: "Contenedores",
        data: statusValues,
        backgroundColor: colors,
        hoverOffset: 10,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: "Estados de contenedores",
        font: {
          size: 16,
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            let value = tooltipItem.raw;
            let percentage = ((value / total) * 100).toFixed(2);
            return `${
              statusLabels[tooltipItem.dataIndex]
            }: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  const blueStyle = {color: "#007bff", fontWeight: "bold"};
  const greenStyle = {color: "#28a745", fontWeight: "bold"};
  const orangeStyle = {color: "#fd7e14", fontWeight: "bold"};

  const borderStyle = {
    border: "1px solid #dee2e6",
    borderCollapse: "collapse",
    fontSize: "15px",
    height: "80px",
  };

  return (
    <div>
      <div className="mb-4">
        <table className="table" style={borderStyle}>
          <thead>
            <tr className="text-center">
              <th className="align-middle" style={blueStyle}>
                Contenedores Totales
              </th>
              <th className="align-middle" style={greenStyle}>
                Con Sensor
              </th>
              <th className="align-middle" style={orangeStyle}>
                Sin Sensor
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="align-middle" style={blueStyle}>
                {data.assets.total}
              </td>
              <td className="align-middle" style={greenStyle}>
                {data.assets.has}
              </td>
              <td className="align-middle" style={orangeStyle}>
                {data.assets.out}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="border pb-3" style={{height: "266px"}}>
        <Doughnut data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default AssetStatus;
